package settings.diagnosisSetting.components


import antd.checkbox.checkboxGroup
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.input.inputGroup
import antd.modal.modal
import antd.radio.radioGroup
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.data.type.BigDecimal
import com.jingfangpai.common.orm.mapping.DiagnosisSetting
import com.jingfangpai.common.orm.mapping.enums.DiagnosisSettingPersonType
import com.jingfangpai.common.orm.mapping.enums.DiagnosisSettingSex
import com.jingfangpai.common.orm.mapping.enums.DiagnosisSettingType
import com.jingfangpai.signSymptom.model.SignSymptomNames
import ext.isNumber
import external.toJsObject
import kotlinext.js.Object
import kotlinext.js.js
import react.*
import react.dom.*
import kotlin.reflect.KMutableProperty1

external interface DiagnosisSettingModalProps : RProps {
  var visibility:Boolean?
  var updateVisibility:(Boolean)->Unit
  var currentSetting:DiagnosisSetting
  var saveSetting:(setting:com.jingfangpai.common.orm.mapping.DiagnosisSetting, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.DiagnosisSetting>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
  var onSaved:(savedSetting:DiagnosisSetting)->Unit
//var symptomOptions:Array<CascadedOption<String>>
}

data class DiagnosisSettingSettingModalContextData(var placeHolderFunction: (param: String) -> Unit)

val DiagnosisSettingModal = functionalComponent<DiagnosisSettingModalProps> { props ->

    //val ctx = useContext(SignSymptomSettingModalPageContext)
    val (signSymptomNames,setSignSymptomNames) = useState(SignSymptomNames())
    val (editingForm,setEditingForm) = useState(props.currentSetting)
    val (statusMessage,setStatusMessage) = useState("")

    useEffect(props.currentSetting) {
        setEditingForm(props.currentSetting)
    }

    useEffectOnce {
        /*if(!editingSettingSet.id.isNullOrBlank()){
            //获取以编辑
            props.getAvailableSignSymptoms({ resp->
                if(resp.ok()){
                    setSignSymptomNames(resp.data!!)
                }else{
                    message.error("获取体征症状失败:${resp.message}")
                }
            },{
                message.error("获取体征症状失败:${it.message}")
            })
        }*/
    }

    /**
     * 更新字段设置
     */
    fun updateField(property: KMutableProperty1<DiagnosisSetting, *>, value:dynamic, property2: KMutableProperty1<DiagnosisSetting, *>? = null, value2:dynamic?=null, property3: KMutableProperty1<DiagnosisSetting, *>? = null, value3:dynamic?=null){
        val _form = Object.assign(DiagnosisSetting(),editingForm)
        property.set(_form,value)
        if(property2 != null){
            property2.set(_form,value2)
        }
        if(property3 != null){
            property3.set(_form,value3)
        }
        setEditingForm(_form)
    }

    fun validateForm():Boolean{
        if(editingForm.type == null){
            setStatusMessage("请选择表单类型")
            return false;
        }
        if(editingForm.name.isNullOrBlank()){
            setStatusMessage("请填写表单名称")
            return false;
        }
        if(editingForm.sex == null){
            setStatusMessage("请选择适用性别")
            return false;
        }
        if(editingForm.personType == null){
            setStatusMessage("请选择适用对象")
            return false;
        }
        return true
    }

    fun onSave(){
        if(validateForm()){
            setStatusMessage("保存中，请稍候...")
            props.saveSetting(editingForm,{ resp->
                   if(resp.ok()){
                       setStatusMessage("保存成功！")
                       setEditingForm(resp.data!!)
                       props.onSaved(resp.data!!)
                   }else{
                       setStatusMessage("保存失败：${resp.message}")
                   }
            },{
                setStatusMessage("保存失败：${it.message}")
            })
        }

    }

    modal {
        attrs{
            title = if(editingForm.id.isNullOrBlank()) "新增诊查表单" else "诊查表单编辑"
            visible = props.visibility
            onCancel = {
                props.updateVisibility(false)
            }
            onOk = {
                onSave()
            }
        }
        div{

            form {
                attrs{
                    layout = "horizontal"
                }
                formItem {
                    attrs{
                        label = "说明"
                    }
                    +"此设置中的项目将在条件符合时向使用者呈现"
                }

                formItem {
                    attrs {
                        label = "设置类型"
                    }
                    radioGroup {
                        attrs{
                            options = DiagnosisSettingType.values().map {
                                    item -> CascadedOption<String>(item.getLiteral(),item.getLiteral())
                            }.toTypedArray().toJsObject()
                            value = editingForm.type
                            onChange = { event ->
                                updateField(DiagnosisSetting::type,DiagnosisSettingType.valueOf(event.target.value as String))
                            }
                        }
                    }
                    /*checkboxGroup{
                        attrs {
                            options = DiagnosisSettingType.values().map {
                                    item -> CascadedOption<DiagnosisSettingType>(item.name,item,if((editingForm.type?.equals(DiagnosisSettingType.系统默认)?:false) && item != DiagnosisSettingType.系统默认) true else false)
                            }.toTypedArray().toJsObject()
                            value = editingForm.type
                            onChange = {checkedValue:Array<DiagnosisSettingType>->updateField(DiagnosisSetting::type,if(checkedValue.equals(DiagnosisSettingType.系统默认)) setOf(DiagnosisSettingType.系统默认) else checkedValue.toHashSet())}
                        }
                    }*/
                }

                formItem {
                    attrs{
                        label = "设置名称"
                        help = "请填写一个易于识别的名称，如“孕妇专用”、“少阳病诊查”"
                    }
                    input {
                        attrs {
                            value = editingForm.name
                            onChange = {event: dynamic ->
                                updateField(DiagnosisSetting::name,event.target.value as String)
                            }
                        }
                    }
                }
                formItem {
                    attrs {
                        label = "适用性别"
                    }
                    checkboxGroup{
                        attrs {
                            options = DiagnosisSettingSex.values().map {
                                    item -> CascadedOption<DiagnosisSettingSex>(item.name,item,if((editingForm.sex?.contains(DiagnosisSettingSex.不限)?:false) && item != DiagnosisSettingSex.不限) true else false)
                            }.toTypedArray().toJsObject()
                            value = editingForm.sex?.toTypedArray()
                            onChange = {checkedValue:Array<DiagnosisSettingSex>->updateField(DiagnosisSetting::sex,if(checkedValue.contains(DiagnosisSettingSex.不限)) setOf(DiagnosisSettingSex.不限) else checkedValue.toHashSet())}
                        }
                    }
                }
                formItem {
                    attrs {
                        label = "适用对象"
                    }
                    checkboxGroup{
                        attrs {
                            options = DiagnosisSettingPersonType.values().map {
                                    item -> CascadedOption<DiagnosisSettingPersonType>(item.name,item,if((editingForm.personType?.contains(DiagnosisSettingPersonType.不限)?:false) && item != DiagnosisSettingPersonType.不限) true else false)
                            }.toTypedArray().toJsObject()
                            value = editingForm.personType?.toTypedArray()
                            onChange = {checkedValue:Array<DiagnosisSettingPersonType>->updateField(DiagnosisSetting::personType,if(checkedValue.contains(DiagnosisSettingPersonType.不限)) setOf(DiagnosisSettingPersonType.不限) else checkedValue.toHashSet())}
                        }
                    }
                }
                /*formItem{
                    attrs{
                        label = "包含症状"
                    }
                    select<String, SelectComponent<String>> {
                        attrs {
                            mode = "default"
                            labelInValue = false
                            value = editingForm.withSignSymptom
                            placeholder = "选择症状"
                            optionLabelProp = "label"
                            *//*notFoundContent = if (state.fetching) {
                                buildElement {
                                    spin {
                                        attrs.size = "small"
                                    }
                                }
                            } else null*//*
                            filterOption = ::filterOptionFun
                            //onSearch = fetchUser
                            onChange = { selected: String, any: Any ->
                                console.log("select value",selected);
                                updateField(DiagnosisSetting::withSignSymptom,selected)
                            }
                            style = js { width = "100%" }
                        }
                        props.symptomOptions?.forEach { optGroup ->
                            optGroup {
                                attrs{
                                    label = "${optGroup.label}"
                                }
                                optGroup.children?.forEach { opt->
                                    option {
                                        attrs{
                                            label = "${opt.label}"
                                            value = "${opt.value}"
                                        }
                                        +"${opt.label}"
                                    }
                                }
                            }
                        }
                    }
                }*/
                formItem{
                    attrs{
                        label = "适用年龄"
                    }
                    inputGroup {
                        attrs {
                            compact = true
                        }

                        input {
                            attrs {
                                type = "text"
                                style = js("{ width: 100, textAlign: 'center' }")
                                placeholder = "下限(>=)"
                                value = editingForm.ageFrom ?: ""
                                onChange = { event: dynamic ->
                                    var str = event.target.value as String;
                                    if (!str.isNullOrBlank() && str.isNumber()) updateField(DiagnosisSetting::ageFrom, str.toInt()) else updateField(DiagnosisSetting::ageFrom, null)
                                }
                            }
                        }
                        input {
                            attrs {
                                style =
                                    js("{width: 30,borderLeft: 0,borderRight: 0,pointerEvents: 'none'}")
                                placeholder = "~"
                                disabled = true
                            }
                        }
                        input {
                            attrs {
                                type = "text"
                                style = js("{ width: 100, textAlign: 'center' }")
                                placeholder = "上限(<=)"
                                value = editingForm.ageTo ?: ""
                                onChange = { event: dynamic ->
                                    var str = event.target.value as String;if (!str.isNullOrBlank() && str.isNumber()) updateField(DiagnosisSetting::ageTo, str.toInt()) else updateField(DiagnosisSetting::ageTo, null)
                                }
                            }
                        }
                    }
                }
                formItem{
                    attrs{
                        label = "BMI范围"
                    }
                    inputGroup {
                        attrs {
                            compact = true
                        }

                        input {
                            attrs {
                                type = "text"
                                style = js("{ width: 100, textAlign: 'center' }")
                                placeholder = "下限(>=)"
                                value = editingForm.bmiFrom ?: ""
                                onChange = { event: dynamic ->
                                    var str = event.target.value as String;if (!str.isNullOrBlank()) updateField(DiagnosisSetting::bmiFrom, BigDecimal(str)) else updateField(DiagnosisSetting::bmiFrom, null)
                                }
                            }
                        }
                        input {
                            attrs {
                                style =
                                    js("{width: 30,borderLeft: 0,borderRight: 0,pointerEvents: 'none'}")
                                placeholder = "~"
                                disabled = true
                            }
                        }
                        input {
                            attrs {
                                type = "text"
                                style = js("{ width: 100, textAlign: 'center' }")
                                placeholder = "上限(<=)"
                                value = editingForm.bmiTo ?: ""
                                onChange = { event: dynamic ->
                                    var str = event.target.value as String;if (!str.isNullOrBlank()) updateField(DiagnosisSetting::bmiTo, BigDecimal(str)) else updateField(DiagnosisSetting::bmiTo, null)
                                }
                            }
                        }
                    }
                }
                formItem{
                    attrs{
                        label = "腰围身高比"
                    }
                    inputGroup {
                        attrs {
                            compact = true
                        }

                        input {
                            attrs {
                                type = "text"
                                style = js("{ width: 100, textAlign: 'center' }")
                                placeholder = "下限(>=)"
                                value = editingForm.whtrFrom ?: ""
                                onChange = { event: dynamic ->
                                    var str = event.target.value as String;
                                    if (!str.isNullOrBlank()) updateField(DiagnosisSetting::whtrFrom, BigDecimal(str)) else updateField(DiagnosisSetting::whtrFrom, null)
                                }
                            }
                        }
                        input {
                            attrs {
                                style =
                                    js("{width: 30,borderLeft: 0,borderRight: 0,pointerEvents: 'none'}")
                                placeholder = "~"
                                disabled = true
                            }
                        }
                        input {
                            attrs {
                                type = "text"
                                style = js("{ width: 100, textAlign: 'center' }")
                                placeholder = "上限(<=)"
                                value = editingForm.whtrTo ?: ""
                                onChange = { event: dynamic ->
                                    var str = event.target.value as String;if (!str.isNullOrBlank()) updateField(DiagnosisSetting::whtrTo, BigDecimal(str)) else updateField(DiagnosisSetting::whtrTo, null)
                                }
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "使用次序"
                    }
                    input {
                        attrs {
                            type = "number"
                            value = editingForm.weight ?:1
                            placeholder = "请填写排序位置"
                            onChange = {event: dynamic ->
                                var str = event.target.value as String;
                                if (!str.isNullOrBlank() && str.isNumber()) updateField(DiagnosisSetting::weight, str.toInt()) else updateField(DiagnosisSetting::weight, null)
                            }
                        }
                    }
                }
                if(!statusMessage.isNullOrBlank()){
                    formItem{
                        span {
                           this.attrs{
                               jsStyle = js{
                                   color = "red"
                               }
                           }
                            +statusMessage
                        }
                    }
                }
            }
        }
    }
}
